module.exports = __webpack_public_path__ + "static/media/dev-6.4b3f0a5c.png";